import { render } from "./SelecionarTipoOperacao.vue?vue&type=template&id=b99851c2&scoped=true&ts=true"
import script from "./SelecionarTipoOperacao.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoOperacao.vue?vue&type=script&lang=ts"

import "./SelecionarTipoOperacao.vue?vue&type=style&index=0&id=b99851c2&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99851c2"]])

export default __exports__